import {
    AutoStories,
    Calculate,
    Create,
    Description,
    Exposure,
    Factory,
    Home,
    Logout,
    NewReleases,
    NotificationsActive,
    Paid,
    PeopleAlt,
    PersonAdd,
    TableChart,
    RequestQuote,
    Analytics,
    Camera,
} from "@mui/icons-material";
import { Collapse, ListItemText, MenuList, Typography } from "@mui/material";
import { ItemButton, ItemIcon, Links, ListItemSubMenu } from "./styles";

import { useAuth } from "../../../../context/global";
import { useHistory } from "react-router-dom";
import { useState } from "react";

interface IMenuItem {
    item: any;
    showSubmenu: boolean | number;
    menuSelected: any;
    alterMenuSelected: any;
    id?: string;
}

function Menus({ item, showSubmenu, menuSelected, alterMenuSelected, id }: IMenuItem) {
    const { sidebarOpen, setSidebarOpen, handleLogout, handleGetDataUser } = useAuth();
    const history = useHistory();
    const [open, setOpen] = useState<boolean>(false);
    const user = handleGetDataUser();

    const renderIcon = (icon: any) => {
        switch (icon) {
            case "personAdd":
                return <PersonAdd />;
            case "new_releases":
                return <NewReleases />;
            case "paid":
                return <Paid />;
            case "factory":
                return <Factory />;
            case "peopleAlt":
                return <PeopleAlt />;
            case "create":
                return <Create />;
            case "description":
                return <Description />;
            case "notificationsActive":
                return <NotificationsActive />;
            case "autoStories":
                return <AutoStories />;
            case "calculate":
                return <Calculate />;
            case "logout":
                return <Logout />;
            case "tableChart":
                return <TableChart />;
            case "exposure":
                return <Exposure style={{ transform: "rotate(180deg)" }} />;
            case "requestQuote":
                return <RequestQuote />;
            case "analytics":
                return <Analytics />;
            case "camera":
                return <Camera />;
            default:
                return <Home />;
        }
    };

    const handleOpen = () => {
        setOpen(!open);
        if (sidebarOpen === false) {
            setSidebarOpen(!sidebarOpen);
        }
    };

    const handleSelected = (e: any) => {
        alterMenuSelected(e.currentTarget.title);
    };

    return (
        <>
            <ItemButton
                expaned={showSubmenu ? 1 : 0}
                onClick={(e) => {
                    if (item.title === "Sair") {
                        handleLogout();
                    }
                    handleSelected(e);
                    item.router ? history.push(item.router) : handleOpen();
                }}
                title={item.title}
                selected={item.title === menuSelected ? true : false}
                id={id}
            >
                <ItemIcon>{renderIcon(item.icon)}</ItemIcon>
                {showSubmenu && <ListItemText primary={item.title} />}
            </ItemButton>

            {item && item.children && showSubmenu && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <MenuList component="div" disablePadding sx={{ ml: 5 }}>
                        {item.children.map((e: any, index: number) => {
                            return (
                                <div key={index}>
                                    {user &&
                                        user.perfil &&
                                        e.permissions &&
                                        e.permissions.includes(user.perfil.toLowerCase()) && (
                                            <Links
                                                to={e.router}
                                                onClick={() => {
                                                    alterMenuSelected(item.title);
                                                }}
                                            >
                                                <ListItemSubMenu key={index} menupai={item.title}>
                                                    <Typography style={{ fontSize: 14 }}>{e.title}</Typography>
                                                </ListItemSubMenu>
                                            </Links>
                                        )}
                                </div>
                            );
                        })}
                    </MenuList>
                </Collapse>
            )}
        </>
    );
}

export default Menus;
